<!-- src/pages/WcSearchFormPage.vue -->
<template>
    <h3 class="page-title">智能搜索</h3>
    <WcSearchForm @submit="wc_serach" :isWcSubmitting="isWcSubmitting" />
   <div v-if="wencaiData">
      <ChildTable :response-data="wencaiData"  @fetch-data="fetchData" />
    </div>
</template>

<script>
import WcSearchForm from '@/components/WcSearchForm.vue';
import ChildTable from '@/components/ChildTable.vue'; // 修改路径
import axios from 'axios';
export default {
  components: {
    WcSearchForm,
    ChildTable
  },
  data() {
    return {
      data: {},
      isWcSubmitting: false
    };
  },
  methods: {
    async wc_serach(searchQuery) {
      if (this.isWcSubmitting) return;
      console.log('开始请求数据:', searchQuery);
      this.isWcSubmitting = true;
      try {
        const response = await axios.get(`/api/wc_search?question=${searchQuery}`);
        const responseData = response.data;
        if (responseData.length == 0) {
          alert('没有找到相关数据，请检查输入的其他搜索条件是否正确。');
          this.data = {};
          this.tableData = [];
        } else {
          this.wencaiData = responseData;
        }
      } catch (error) {
        console.error('数据获取失败:', error);
        alert('数据获取失败，请检查网络连接或服务器状态。');
      } finally {
        this.isWcSubmitting = false;
        console.log('请求完成');
      }
    }
  }
};
</script>
